import React from 'react';
import { DrawerV2 } from '@withjoy/joykit';
import type { ProductList } from './ShoppingCartInner';
import { ShoppingCartInner } from './ShoppingCartInner';
import type { RegistryOrderFragment } from '@graphql/fragments/registry.graphql.generated';
import type { ShippingAddressFragment } from '@graphql/fragments/shippingAddress.graphql.generated';
import type { useRoutePaths } from '@apps/registry/guest/GuestRegistry.routes';

interface ShoppingCartDialogProps
  extends Readonly<{
    isOpen: boolean;
    eventId: string;
    shippingAddress: ShippingAddressFragment | null;
    isShoppingPage?: boolean;
    helpDialogOpen: boolean;
    productList: ProductList;
    reservedOrderList: RegistryOrderFragment[];
    purchasedOrderList: RegistryOrderFragment[];
    orderCount: number;
    cartOrderCount: number;
    cartTotal: string;
    paths: ReturnType<typeof useRoutePaths>;
    onClose?: () => void;
    showHelpDialog: () => void;
    handleDialogClose: () => void;
  }> {}

export const ShoppingCartDialog: React.FC<ShoppingCartDialogProps> = ({
  isOpen,
  eventId,
  shippingAddress,
  isShoppingPage,
  helpDialogOpen,
  productList,
  reservedOrderList,
  purchasedOrderList,
  orderCount,
  cartOrderCount,
  cartTotal,
  paths,
  onClose,
  showHelpDialog,
  handleDialogClose,
}) => {
  return (
    <DrawerV2
      isOpen={isOpen}
      onClose={onClose}
      anchor="right"
      size={374}
      overrides={{
        Content: { props: { maxWidth: '100vw' } },
      }}
    >
      <DrawerV2.Body
        paddingX={0}
        paddingY={0}
        display="flex"
        flexDirection="column"
      >
        <ShoppingCartInner
          eventId={eventId}
          shippingAddress={shippingAddress}
          isShoppingPage={isShoppingPage}
          helpDialogOpen={helpDialogOpen}
          productList={productList}
          reservedOrderList={reservedOrderList}
          purchasedOrderList={purchasedOrderList}
          orderCount={orderCount}
          cartOrderCount={cartOrderCount}
          cartTotal={cartTotal}
          paths={paths}
          onClose={onClose}
          showHelpDialog={showHelpDialog}
          handleDialogClose={handleDialogClose}
        />
      </DrawerV2.Body>
    </DrawerV2>
  );
};

ShoppingCartDialog.displayName = 'ShoppingCartDialog';
